import { useQuery } from '@apollo/client';
import type { Topic } from '@communities/content-management/domain';
import { GET_COMMUNITY_GROUP_TOPICS } from '@communities/content-management/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityGroupTopicsResponse {
  communityGroup: {
    id: string;
    topics: Topic[];
  } | null;
}

export function useCommunityGroupTopics(communityGroupId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityGroupTopicsResponse>(GET_COMMUNITY_GROUP_TOPICS, {
    variables: { communityGroupId },
    fetchPolicy: 'cache-first',
    skip: !communityGroupId,
  });

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  const topics: Topic[] = data?.communityGroup?.topics || [];

  return {
    topics,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityGroupTopics;
